import LABEL from '../../../business-const/Label/Label'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import MESSAGE from '../../../business-const/Message/Message'

import {
    ano,
    converteMesesEmAnosMeses,
    formataMesAnoSemBarra,
} from '../../../business-components/Date/Date'

import {
    nvl,
    formataValor,
    formataPerc,
    formataAIFT,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import tipoReceitaMensalList from '../../../business-rules/List/tipoReceitaMensalList'

import tipoDiaDiaList from '../../../business-rules/List/tipoDiaDiaList'

import {
    objetoCliente,
} from '../cliente-form/ClienteService'

import {
    possuiFilhao,
} from '../cadastro-form/CadastroServiceFamiliares'

import {
    tituloCliente,
    tituloConjuge,
    calculaValorPerc,
} from '../cliente-form/ClienteService'

import {
    ateMaisXAnos,
} from '../estudo-form/EstudoService'

import {
    incrementaContDiaDia,
} from '../despesas-form/DespesasServiceDiaDia'

import {
    inicializaEstudo,
    processaCalculoEstudo,
    calculaIdadeValorNegativo,
    calculaJaAposentou,
} from '../estudo-form/EstudoServiceCalculo'

import {
    complementaValuesAposObjetoCliente,
} from '../estudo-form/EstudoServiceComparacaoCenariosEstudos'

import {
    consideraReceitaMensal,
} from '../estudo-form/EstudoServiceGarantiasReceitaMensal'

import {
    obtemContReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    obtemContRecursosFinanceiros,
    FGTS,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    calculaValorCS,
} from '../seguroVida-form/SeguroVidaService'

import DiagnosticoAposentadoriaChart from '../estudo-chart/DiagnosticoAposentadoriaChart'

import DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart from
    '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart'

//import ReceitaAnualChart from '../estudo-chart/ReceitaAnualChart'

//import DespesaAnualChart from '../estudo-chart/DespesaAnualChart'

import BalancoReceitaXDespesaAnualChart from '../estudo-chart/BalancoReceitaXDespesaAnualChart'



const calculaReceitaAnual = (values, estudo, dadosAIFT) => {

    dadosAIFT.current.analisesInformacoesReceitaAnualChart = false
    dadosAIFT.current.rendaTotalAntesAposentar = 0
    dadosAIFT.current.mesesRendaTotalAntesAposentar = 0
    dadosAIFT.current.rendaTotalDepoisAposentar = 0
    dadosAIFT.current.mesesRendaTotalDepoisAposentar = 0

    estudo.current.graficoIdades?.forEach( (linha, ind) => {

        if (linha <= values.idadeVaiAposentarCliente) {

            dadosAIFT.current.rendaTotalAntesAposentar += estudo.current.graficoReceitaAnualTotal[ind]

            dadosAIFT.current.mesesRendaTotalAntesAposentar += ind === 0 ? estudo.current.mesesAnoAtual : 12

        } else {

            dadosAIFT.current.rendaTotalDepoisAposentar += estudo.current.graficoReceitaAnualTotal[ind]

            dadosAIFT.current.mesesRendaTotalDepoisAposentar += 12
        }
    })

    dadosAIFT.current.mediaMensalRendaTotalAntesAposentar = round(dadosAIFT.current.rendaTotalAntesAposentar / 
        dadosAIFT.current.mesesRendaTotalAntesAposentar, 2)

    dadosAIFT.current.mediaMensalRendaTotalDepoisAposentar = round(dadosAIFT.current.rendaTotalDepoisAposentar / 
        dadosAIFT.current.mesesRendaTotalDepoisAposentar, 2)

    dadosAIFT.current.percQuedaRendaMensalDepoisAposentar = round(100 - (dadosAIFT.current.mediaMensalRendaTotalDepoisAposentar / 
        dadosAIFT.current.mediaMensalRendaTotalAntesAposentar * 100), 2)

    if (dadosAIFT.current.rendaTotalAntesAposentar > 0/* || dadosAIFT.current.rendaTotalDepoisAposentar > 0*/) {

        dadosAIFT.current.analisesInformacoesReceitaAnualChart = true
    }
}



const calculaCapacidadePoupanca = (values, estudo, dadosAIFT) => {

    dadosAIFT.current.analisesInformacoesBalancoReceitaXDespesaAnualChart = false
    dadosAIFT.current.capacidadePoupancaTotal = 0
    dadosAIFT.current.mesesCapacidadePoupancaTotal = 0

    estudo.current.graficoIdades?.forEach( (linha, ind) => {

        if (linha <= values.idadeVaiAposentarCliente) {

            if (
                    estudo.current.graficoBalancoAnualTotalComTracarMetaAporte[ind] > 0 ||
                    estudo.current.graficoAporteAposentadoriaEconomiaReceitaMensalTotal[ind] > 0
            ) {

                dadosAIFT.current.capacidadePoupancaTotal +=
                    nvl(estudo.current.graficoBalancoAnualTotalComTracarMetaAporte[ind], 0) +
                        nvl(estudo.current.graficoAporteAposentadoriaEconomiaReceitaMensalTotal[ind], 0)
                        
                dadosAIFT.current.mesesCapacidadePoupancaTotal += ind === 0 ? estudo.current.mesesAnoAtual : 12
            }
        }
    })

    dadosAIFT.current.mediaMensalCapacidadePoupancaTotal = round(dadosAIFT.current.capacidadePoupancaTotal / 
        dadosAIFT.current.mesesCapacidadePoupancaTotal, 2)

    if (dadosAIFT.current.capacidadePoupancaTotal > 0/* && values.valorPresenteDeficitSimulacaoMensal ???> 0???*/) {

        dadosAIFT.current.analisesInformacoesBalancoReceitaXDespesaAnualChart = true
    }
}

const identificaProtecaoSugerida = (protecaoSugerida, descricao) => {

    let linhaProtecaoSugerida = {
        valorCS2: 0,
    }

    protecaoSugerida?.forEach( (linha, ind) => {

        if (linha.descricaoTrim === descricao) {
            
            linhaProtecaoSugerida = linha
        }
    })

    return linhaProtecaoSugerida
}

const calculaProtecaoSugerida = (values, estudo, aiFTOrigem, dadosAIFT) => {

    dadosAIFT.current.analisesInformacoesEstudoFormProtecaoSugerida = false

    let protecaoSugerida

    if (aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente) {

        protecaoSugerida = values.protecaoSugeridaCliente

    } else {

        protecaoSugerida = values.protecaoSugeridaConjuge
    }

    if (
            protecaoSugerida &&
            protecaoSugerida.length > 0 &&
            !values.utilizarPercRentabilidadeAnualRecursosFinanceiros &&
            !values.naoAplicarTaxaJurosSeguroVida &&
            values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoMorte &&
            !estudo.current.temValorCompraAIFT
    ) {

        const linhaProtecaoSugerida = identificaProtecaoSugerida(protecaoSugerida, LABEL.proporcionarConfortoFamilia)

        dadosAIFT.current.analisesInformacoesEstudoFormProtecaoSugerida = linhaProtecaoSugerida.valorCS2 > 0
    }
}

export const calculaExibeAIFT = (aiFTOrigem, values, estudo, dadosAIFT) => {

    let exibeAIFT = false

    const jaAposentou = calculaJaAposentou(values, ano(values.dataSimulacaoEstudo))

    if (aiFTOrigem === HARDCODE.analisesInformacoesReceitaAnualChart) {
        
        if (!jaAposentou) {

            calculaReceitaAnual(values, estudo, dadosAIFT)
        
            exibeAIFT = dadosAIFT.current.analisesInformacoesReceitaAnualChart
        }

    } else {

        if (aiFTOrigem === HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart) {

            if (!jaAposentou) {
    
                calculaCapacidadePoupanca(values, estudo, dadosAIFT)
    
                exibeAIFT = dadosAIFT.current.analisesInformacoesBalancoReceitaXDespesaAnualChart
            }

        } else {

            if (
                    aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente ||
                    aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge
            ) {

                calculaProtecaoSugerida(values, estudo, aiFTOrigem, dadosAIFT)

                exibeAIFT = dadosAIFT.current.analisesInformacoesEstudoFormProtecaoSugerida
            }
        }
    }

    return exibeAIFT
}



const geraValuesAIFT = (variaveisGlobais, values) => {

    const valuesAIFT = JSON.parse(JSON.stringify(objetoCliente(variaveisGlobais, values, null, null)))
    complementaValuesAposObjetoCliente(valuesAIFT, values, values.versao)

    return valuesAIFT
}

const processaCalculoEstudoAIFT = (valuesAIFT, estudoAIFT, origem, vars) => {

    const handleSubmitAutomatico = ''
    const report = false

    processaCalculoEstudo(valuesAIFT, handleSubmitAutomatico, estudoAIFT, report, false,
        origem , /*true*/false, vars.jsonConfiguracao, false)
}

const calculaIdadeAnteciparAposentadoria = (values, valuesAIFT, estudoAIFT, vars, mensagemAIFT, idadeExpectativaVidaCliente) => {

    if (
            !valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte ||
            valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte > values.idadeFinalVitalicioClienteConjuge
    ) {

        valuesAIFT.idadeExpectativaVidaCliente = values.idadeExpectativaVidaCliente

        let idadeVaiAposentarClientePreservarRecursosFinanceiros = ''
        let valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria = ''
        let valorRetiradaMensalMaximaPreservarReservaAposentadoria = ''
        
        while (
                (
                    !valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte ||
                    valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte >= values.idadeFinalVitalicioClienteConjuge
                ) &&
                valuesAIFT.idadeVaiAposentarCliente >= valuesAIFT.idadeDataSimulacaoCliente
        ) {

            if (valuesAIFT.valorAporteMensalPreservarReservaAposentadoria === 0) {

                idadeVaiAposentarClientePreservarRecursosFinanceiros = valuesAIFT.idadeVaiAposentarCliente
                valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria =
                    valuesAIFT.valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria
                valorRetiradaMensalMaximaPreservarReservaAposentadoria =
                    valuesAIFT.valorRetiradaMensalMaximaPreservarReservaAposentadoria
            }

            valuesAIFT.idadeVaiAposentarCliente -= 1

            processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)
        }

        valuesAIFT.idadeVaiAposentarCliente += 1

        processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)

        if (
                valuesAIFT.idadeVaiAposentarCliente !== values.idadeVaiAposentarCliente &&
                valuesAIFT.idadeVaiAposentarCliente !== idadeVaiAposentarClientePreservarRecursosFinanceiros
        ) {

            mensagemAIFT += HARDCODE.htmlPularLinha +
                MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAnteciparAposentadoria
                    .replace('$values.idadeVaiAposentarCliente$',
                        values.idadeVaiAposentarCliente)
                    .replace('$valuesAIFT.idadeVaiAposentarCliente$',
                        valuesAIFT.idadeVaiAposentarCliente)
                    .replace('$valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria$',
                        formataValor(valuesAIFT.valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria, 2))
                    .replace('$idadeFinalVitalicioClienteConjuge$', values.idadeFinalVitalicioClienteConjuge)

            valuesAIFT.idadeVaiAposentarCliente = values.idadeVaiAposentarCliente
        }

        if (
                idadeVaiAposentarClientePreservarRecursosFinanceiros &&
                idadeVaiAposentarClientePreservarRecursosFinanceiros !== values.idadeVaiAposentarCliente
        ) {

            valuesAIFT.idadeVaiAposentarCliente === idadeVaiAposentarClientePreservarRecursosFinanceiros
                ?
                    mensagemAIFT += HARDCODE.htmlPularLinha +
                        MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAnteciparAposentadoriaPreservarRecursosFinanceirosPodeAposentarAgora
                            .replace('$values.idadeVaiAposentarCliente$',
                                values.idadeVaiAposentarCliente)    
                            .replace('$idadeVaiAposentarClientePreservarRecursosFinanceiros$',
                                idadeVaiAposentarClientePreservarRecursosFinanceiros)
                            .replace('$valorRetiradaMaximaPreservarRecursosFinanceiros$',
                                formataValor(valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2))
                            .replace('$valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria$',
                                formataValor(valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria, 2))
                            .replace('$rendaVitaliciaFilhao$', possuiFilhao(values) ? MESSAGE().rendaVitaliciaFilhao : '')
                :
                    mensagemAIFT += HARDCODE.htmlPularLinha +
                        MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAnteciparAposentadoriaPreservarRecursosFinanceiros
                            .replace('$idadeVaiAposentarClientePreservarRecursosFinanceiros$',
                                idadeVaiAposentarClientePreservarRecursosFinanceiros)
                            .replace('$valorRetiradaMaximaPreservarRecursosFinanceiros$',
                                formataValor(valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2))
                            .replace('$valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria$',
                                formataValor(valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria, 2))
                            .replace('$rendaVitaliciaFilhao$', possuiFilhao(values) ? MESSAGE().rendaVitaliciaFilhao : '')
        }

        valuesAIFT.idadeVaiAposentarCliente = values.idadeVaiAposentarCliente
        valuesAIFT.idadeExpectativaVidaCliente = idadeExpectativaVidaCliente
    }

    return mensagemAIFT
}

const calculaCenarioAporteCapacidadePoupanca = (values, valuesAIFT, estudoAIFT, vars, mensagemAIFT) => {

    const idadeExpectativaVidaCliente = 150

    valuesAIFT.alterarIdadesAutomaticasCliente = true
    valuesAIFT.idadeExpectativaVidaCliente = idadeExpectativaVidaCliente

    valuesAIFT.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = true
    valuesAIFT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = 80
    
    processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)

    if (
            !valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte ||
            valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte > values.idadeFinalVitalicioClienteConjuge
    ) {

        mensagemAIFT += HARDCODE.htmlDivider +
            MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAporte80
                .replace('$percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria$',
                    valuesAIFT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria)
                .replace('$valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria$',
                    formataValor(valuesAIFT.valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria, 2))
                .replace('$recursosFinanceirosAcumuladosAposentadoriaIdadeAte$',
                    ateMaisXAnos(valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte, valuesAIFT.idadeExpectativaVidaCliente))

        if (valuesAIFT.valorAporteMensalPreservarReservaAposentadoria === 0) {
        
            mensagemAIFT = mensagemAIFT.substring(0, mensagemAIFT.length - 1) +
                MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartReceitaVitalicia
                    .replace('$valorRetiradaMaximaPreservarRecursosFinanceiros$',
                        formataValor(valuesAIFT.valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2))
        }

        mensagemAIFT = calculaIdadeAnteciparAposentadoria(values, valuesAIFT, estudoAIFT, vars, mensagemAIFT, idadeExpectativaVidaCliente)

        //estudoAIFT.current = inicializaEstudo()
        valuesAIFT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = 50

        processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)

        mensagemAIFT += HARDCODE.htmlDivider +
            MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAporte50
                .replace('$percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria$',
                    valuesAIFT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria)
                .replace('$valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria$',
                    formataValor(valuesAIFT.valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria, 2))
                .replace('$recursosFinanceirosAcumuladosAposentadoriaIdadeAte$',
                    ateMaisXAnos(valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte, valuesAIFT.idadeExpectativaVidaCliente))

        if (valuesAIFT.valorAporteMensalPreservarReservaAposentadoria === 0) {
        
            mensagemAIFT = mensagemAIFT.substring(0, mensagemAIFT.length - 1) +
                MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartReceitaVitalicia
                    .replace('$valorRetiradaMaximaPreservarRecursosFinanceiros$',
                        formataValor(valuesAIFT.valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2))
        }

        mensagemAIFT = calculaIdadeAnteciparAposentadoria(values, valuesAIFT, estudoAIFT, vars, mensagemAIFT, idadeExpectativaVidaCliente)

    } else {

        mensagemAIFT += HARDCODE.htmlPularLinha +
            MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAumentoReceitasReducaoDespesas
                .replace('$percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria$',
                    valuesAIFT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria)
                .replace('$recursosFinanceirosAcumuladosAposentadoriaIdadeAte$',
                    valuesAIFT.recursosFinanceirosAcumuladosAposentadoriaIdadeAte)
                .replace('$idadeFinalVitalicioClienteConjuge$', values.idadeFinalVitalicioClienteConjuge)
    }

    return mensagemAIFT
}



const incluirExclusaoDespesasGarantias = (valuesAIFT, array, id) => {

    if (!valuesAIFT.exclusaoDespesasGarantias) {

        valuesAIFT.exclusaoDespesasGarantias = JSON.parse(JSON.stringify(HARDCODE.exclusaoDespesasGarantiasInit))
    }
                        
    valuesAIFT.exclusaoDespesasGarantias.push(
        {
            id: array + '/' + id
        }
    )
}



export const calculaAnaliseInformacoes = (aiFTOrigem, variaveisGlobais, values, estudo, vars, report, dadosAIFT, estudoAIFT, estudoAIFT2) => {

    const valuesAIFT = geraValuesAIFT(variaveisGlobais, values)
    estudoAIFT.current = inicializaEstudo()

    let mensagemAIFT

    if (dadosAIFT.current.analisesInformacoesReceitaAnualChart) {

        if (values.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria) {

            valuesAIFT.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = false
            
            processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)

            dadosAIFT.current.valorPresenteDeficitSimulacaoMensal = valuesAIFT.valorPresenteDeficitSimulacaoMensal
            dadosAIFT.current.valorAporteMensalPreservarReservaAposentadoria = valuesAIFT.valorAporteMensalPreservarReservaAposentadoria

        } else {

            dadosAIFT.current.valorPresenteDeficitSimulacaoMensal = values.valorPresenteDeficitSimulacaoMensal
            dadosAIFT.current.valorAporteMensalPreservarReservaAposentadoria = values.valorAporteMensalPreservarReservaAposentadoria
        }

        mensagemAIFT = MESSAGE().analiseAIFTReceitaAnualChart
            .replace('$idadeVaiAposentarCliente$', values.idadeVaiAposentarCliente)
            .replace('$rendaTotalAntesAposentar$', formataValor(dadosAIFT.current.rendaTotalAntesAposentar, 2))
            .replace('$mesesRendaTotalAntesAposentar$', dadosAIFT.current.mesesRendaTotalAntesAposentar)
            .replace('$anosMesesRendaTotalAntesAposentar$',
                converteMesesEmAnosMeses(dadosAIFT.current.mesesRendaTotalAntesAposentar))
            .replace('$mediaMensalRendaTotalAntesAposentar$',
                formataValor(dadosAIFT.current.mediaMensalRendaTotalAntesAposentar, 2))
            .replace('$rendaTotalDepoisAposentar$', formataValor(dadosAIFT.current.rendaTotalDepoisAposentar, 2))
            .replace('$mesesRendaTotalDepoisAposentar$', dadosAIFT.current.mesesRendaTotalDepoisAposentar)
            .replace('$anosMesesRendaTotalDepoisAposentar$',
                converteMesesEmAnosMeses(dadosAIFT.current.mesesRendaTotalDepoisAposentar))
            .replace('$mediaMensalRendaTotalDepoisAposentar$',
                formataValor(dadosAIFT.current.mediaMensalRendaTotalDepoisAposentar, 2))

        if (dadosAIFT.current.mediaMensalRendaTotalAntesAposentar > dadosAIFT.current.mediaMensalRendaTotalDepoisAposentar) {

            mensagemAIFT += HARDCODE.htmlDivider + MESSAGE().analiseAIFTReceitaAnualChartQuedaReceita
                .replace('$percQuedaRendaMensalDepoisAposentar$', formataPerc(dadosAIFT.current.percQuedaRendaMensalDepoisAposentar, 2))
                .replace('$mediaMensalRendaTotalAntesAposentar$',
                    formataValor(dadosAIFT.current.mediaMensalRendaTotalAntesAposentar, 2))
                .replace('$mediaMensalRendaTotalDepoisAposentar$',
                    formataValor(dadosAIFT.current.mediaMensalRendaTotalDepoisAposentar, 2))
            
            if (dadosAIFT.current.percQuedaRendaMensalDepoisAposentar > 50) {

                if (dadosAIFT.current.valorPresenteDeficitSimulacaoMensal > 0) {

                    dadosAIFT.current.percValorPresenteDeficitSimulacaoMensalMediaMensalRendaTotalAntesAposentar =
                        round(dadosAIFT.current.valorPresenteDeficitSimulacaoMensal /
                            dadosAIFT.current.mediaMensalRendaTotalAntesAposentar * 100, 2)

                    mensagemAIFT += HARDCODE.htmlPularLinha + MESSAGE().analiseAIFTReceitaAnualChartQuedaReceitaReforcaImportanciaAportes
                        .replace('$percQuedaRendaMensalDepoisAposentar$',
                            formataPerc(dadosAIFT.current.percQuedaRendaMensalDepoisAposentar, 2))
                        .replace('$valorPresenteDeficitSimulacaoMensal$', formataValor(dadosAIFT.current.valorPresenteDeficitSimulacaoMensal, 2))
                        .replace('$idadeFinalVitalicioClienteConjuge$', values.idadeFinalVitalicioClienteConjuge)
                        .replace('$valorPresenteDeficitSimulacaoMensal$', formataValor(dadosAIFT.current.valorPresenteDeficitSimulacaoMensal, 2))
                        .replace('$percValorPresenteDeficitSimulacaoMensalMediaMensalRendaTotalAntesAposentar$',
                            formataPerc(
                                dadosAIFT.current.percValorPresenteDeficitSimulacaoMensalMediaMensalRendaTotalAntesAposentar, 2))
                }

                if (dadosAIFT.current.valorAporteMensalPreservarReservaAposentadoria > 0) {

                    dadosAIFT.current.percvalorAporteMensalPreservarReservaAposentadoriaMediaMensalRendaTotalAntesAposentar =
                        round(dadosAIFT.current.valorAporteMensalPreservarReservaAposentadoria /
                            dadosAIFT.current.mediaMensalRendaTotalAntesAposentar * 100, 2)

                    if (
                            dadosAIFT.current.percvalorAporteMensalPreservarReservaAposentadoriaMediaMensalRendaTotalAntesAposentar
                                <= 30
                    ) {
                        
                        mensagemAIFT += HARDCODE.htmlPularLinha + MESSAGE().analiseAIFTReceitaAnualChartQuedaReceitaReforcaImportanciaAportesViverRentabilidade
                            .replace('$rendaVitaliciaFilhao$', possuiFilhao(values) ? MESSAGE().rendaVitaliciaFilhao : '')
                            .replace('$valorAporteMensalPreservarReservaAposentadoria$', formataValor(dadosAIFT.current.valorAporteMensalPreservarReservaAposentadoria, 2))
                            .replace('$percvalorAporteMensalPreservarReservaAposentadoriaMediaMensalRendaTotalAntesAposentar$', formataPerc(
                                dadosAIFT.current.percvalorAporteMensalPreservarReservaAposentadoriaMediaMensalRendaTotalAntesAposentar, 2))
                    }
                }
            } 
        }

    } else {

        //if (aiFTOrigem === HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart) {

        if (dadosAIFT.current.analisesInformacoesBalancoReceitaXDespesaAnualChart) {

            if (values.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria) {

                valuesAIFT.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = false
                
                processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)

                dadosAIFT.current.valorPresenteDeficitSimulacaoMensal = valuesAIFT.valorPresenteDeficitSimulacaoMensal
                dadosAIFT.current.totalAportesAteAposentadoriaEstudo = valuesAIFT.totalAportesAteAposentadoriaEstudo

            } else {

                dadosAIFT.current.valorPresenteDeficitSimulacaoMensal = values.valorPresenteDeficitSimulacaoMensal
                dadosAIFT.current.totalAportesAteAposentadoriaEstudo = values.totalAportesAteAposentadoriaEstudo
            }

            if (dadosAIFT.current.totalAportesAteAposentadoriaEstudo > 0) {

                mensagemAIFT = MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAportesMensaisAdicionais
                    .replace('$capacidadePoupancaTotal$', formataValor(dadosAIFT.current.capacidadePoupancaTotal, 2))
                    .replace('$mediaMensalCapacidadePoupancaTotal$',
                        formataValor(dadosAIFT.current.mediaMensalCapacidadePoupancaTotal, 2))
                    .replace('$totalAportesAteAposentadoriaEstudo$',
                        formataValor(dadosAIFT.current.totalAportesAteAposentadoriaEstudo, 2))
                
                if (dadosAIFT.current.valorPresenteDeficitSimulacaoMensal > 0) {
                
                    mensagemAIFT += HARDCODE.htmlPularLinha +
                        MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAportesMensaisAdicionaisNecessidadeAporte
                        .replace('$idadeFinalVitalicioClienteConjuge$', values.idadeFinalVitalicioClienteConjuge)
                        .replace('$valorPresenteDeficitSimulacaoMensal$',
                            formataValor(dadosAIFT.current.valorPresenteDeficitSimulacaoMensal, 2))
                }

            } else {

                mensagemAIFT = MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAportesMensais
                    .replace('$capacidadePoupancaTotal$', formataValor(dadosAIFT.current.capacidadePoupancaTotal, 2))
                    .replace('$mediaMensalCapacidadePoupancaTotal$',
                        formataValor(dadosAIFT.current.mediaMensalCapacidadePoupancaTotal, 2))

                if (dadosAIFT.current.valorPresenteDeficitSimulacaoMensal > 0) {

                    mensagemAIFT += HARDCODE.htmlPularLinha +
                        MESSAGE().analiseAIFTBalancoReceitaXDespesaAnualChartAportesMensaisNecessidadeAporte
                        .replace('$idadeFinalVitalicioClienteConjuge$', values.idadeFinalVitalicioClienteConjuge)
                        .replace('$valorPresenteDeficitSimulacaoMensal$',
                            formataValor(dadosAIFT.current.valorPresenteDeficitSimulacaoMensal, 2))
                }
            }
            
            mensagemAIFT = calculaCenarioAporteCapacidadePoupanca(values, valuesAIFT, estudoAIFT, vars, mensagemAIFT)

        } else {

            if (
                    aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente ||
                    aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge
            ) {

                valuesAIFT.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = true
                valuesAIFT.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = 100

                let idFamiliar
                let nomeFamiliar
                let vendaImobilizado
                let valorCSProjetoVidaSonho
                let valorCSMorteTemporariaApolice

                if (aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente) {

                    idFamiliar = HARDCODE.idFamiliarCliente
                    nomeFamiliar = tituloCliente(values)
                    vendaImobilizado =
                        estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado].valorReceitaClientePainel
                    valorCSProjetoVidaSonho = 
                        estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho].valorDespesaClientePainel
                    valorCSMorteTemporariaApolice =
                        calculaValorCS(values, idFamiliar, HARDCODE.idGrupoCoberturaSeguroVidaMorte, null) -
                            values.valorCSVidaInteiraApoliceCliente

                } else {

                    idFamiliar = HARDCODE.idFamiliarConjuge
                    nomeFamiliar = tituloConjuge(values)
                    vendaImobilizado =
                        estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado].valorReceitaConjugePainel
                    valorCSProjetoVidaSonho = 
                        estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho].valorDespesaConjugePainel
                    valorCSMorteTemporariaApolice = 
                        calculaValorCS(values, idFamiliar, HARDCODE.idGrupoCoberturaSeguroVidaMorte, null) -
                            values.valorCSVidaInteiraApoliceConjuge
                }

                valuesAIFT.receitaMensal?.forEach( (linha, ind) => {

                    if (consideraReceitaMensal(values, linha)) {

                        let linhaTipoReceitaMensal = pesquisaList(tipoReceitaMensalList, linha.tipoReceitaMensal)

                        if (
                                (
                                    linha.familiar === idFamiliar &&
                                    linhaTipoReceitaMensal.cobreMorte === 'N'
                                ) ||
                                (
                                    linha.familiar === HARDCODE.idFamiliarCliente &&
                                    linha.naoConsiderarGarantiaMorteCliente
                                ) ||
                                (
                                    linha.familiar === HARDCODE.idFamiliarConjuge &&
                                    linha.naoConsiderarGarantiaMorteConjuge
                                )
                        ) {

                            incluirExclusaoDespesasGarantias(valuesAIFT, LABEL.receitaMensal, linha.id)

                        } else {

                            if (
                                    linha.familiar === idFamiliar &&
                                    (
                                        linha.tipoReceitaMensal === HARDCODE.idTipoReceitaMensalInssRendaMorte ||
                                        linha.tipoReceitaMensal === HARDCODE.idTipoReceitaMensalPensaoRendaMorte
                                    )
                            ) {
                                
                                valuesAIFT.receitaMensal.push(
                                    {
                                        id: obtemContReceitaMensal(valuesAIFT),
                                        familiar: linha.familiar,
                                        tipoReceitaMensal: HARDCODE.idTipoReceitaMensalInssBeneficioAtual,
                                        valor: linha.valor,
                                        tipoPeriodicidadeRecebto: HARDCODE.idTipoPeriodicidadeMensal,
                                    }
                                )
                            }
                        }
                    }
                })

                valuesAIFT.diaDia?.forEach( (linha, ind) => {

                    if (
                            (
                                linha.familiar === idFamiliar &&
                                linha.despesaPessoal
                            )//||
                            //(
                            //    linha.familiar !== idFamiliar &&
                            //    linha.pensaoDependente === "S"
                            //)
                    ) {

                        incluirExclusaoDespesasGarantias(valuesAIFT, LABEL.diaDia, linha.id)

                    } else {

                        let linhaTipoDiaDia = pesquisaList(tipoDiaDiaList, linha.tipoDiaDia)

                        if (linha.familiar === idFamiliar && linhaTipoDiaDia.morte === 'S') {

                            linha.tipoDiaDia = HARDCODE.idTipoDiaDiaOutros

                            if (!linha.descricaoDiversasOutros) {

                                linha.descricaoDiversasOutros = linhaTipoDiaDia.descricao
                            }
                        }
                    }
                })

                if (valorCSProjetoVidaSonho > 0) {

                    if (!valuesAIFT.diaDia) {

                        valuesAIFT.diaDia = []
                    }

                    incrementaContDiaDia(valuesAIFT)
                    valuesAIFT.diaDia.push(
                        {
                            id: valuesAIFT.contDiaDia,
                            familiar: idFamiliar,
                            tipoDiaDia: HARDCODE.idTipoDiaDiaOutros,
                            valor: valorCSProjetoVidaSonho,
                            tipoPeriodicidadePagto: HARDCODE.idTipoPeriodicidadeMensal,
                            alterarPeriodoDiaDia: true,
                            mesAnoInicial: formataMesAnoSemBarra(estudo.current.mesAtual, estudo.current.anoAtual),
                            mesAnoFinal: formataMesAnoSemBarra(estudo.current.mesAtual, estudo.current.anoAtual),
                            consumirRecursosFinanceirosEmVezDaReceitaMensal: true,
                        }
                    )
                }

                valuesAIFT.educacao?.forEach( (linha, ind) => {

                    if (
                            linha.familiar === idFamiliar ||
                            (
                                linha.temSeguro === "S" &&
                                linha.tipoSegurado === "C" &&
                                aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente
                            ) ||
                            (
                                linha.temSeguro === "S" &&
                                linha.tipoSegurado === "O" &&
                                aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge
                            )
                    ) {

                        incluirExclusaoDespesasGarantias(valuesAIFT, LABEL.educacao, linha.id)
                    }
                })

                valuesAIFT.financiamento?.forEach( (linha, ind) => {

                    linha.consumirRecursosFinanceirosEmVezDaReceitaMensal = true

                    if (linha.temSeguro === 'S') {
                        
                        if (
                                (
                                    aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente &&
                                    linha.percSeguroCliente === 100
                                ) ||
                                (
                                    aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge &&
                                    linha.percSeguroConjuge === 100
                                )
                        ) {

                            incluirExclusaoDespesasGarantias(valuesAIFT, LABEL.financiamento, linha.id)

                        } else {

                            const perc =
                                aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente
                                    ?
                                        linha.percSeguroConjuge
                                    :
                                        linha.percSeguroCliente

                            if (linha.tabelaSAC) {

                                linha.valorSaldoDevedor = calculaValorPerc(round(linha.valorSaldoDevedor, 2), perc)

                            } else {

                                linha.valorParcela = calculaValorPerc(round(linha.valorParcela, 2), perc)
                            }

                            if (linha.possuiParcelasAdicionais && linha.parcelasAdicionais) {

                                linha.parcelasAdicionais?.forEach( (linha2, ind2) => {

                                    linha2.valorParcela = calculaValorPerc(round(linha2.valorParcela, 2), perc)
                                })
                            }
                        }
                    }

                    if (linha.valorSaldoDevedor) {

                        linha.valorParcela = linha.valorSaldoDevedor
                        linha.qtdeParcelas = 1
                        linha.tabelaSAC = false
                        linha.consorcio = false
                        linha.possuiParcelasAdicionais = false
                        linha.parcelasAdicionais = []
                        linha.financiamentoFuturo = false
                        linha.mesAnoInicial = ''
                    }
                })

                valuesAIFT.projetoVidaSonho?.forEach( (linha, ind) => {

                    linha.tracarMeta = false
                    
                    if (linha.valorAcumulacaoJaRealizado) {

                        linha.valor = linha.valorAcumulacaoJaRealizado
                    }
                })

                valuesAIFT.recursosFinanceiros?.forEach( (linha, ind) => {

                    if (
                            round(linha.valor, 2) === 0 ||
                            FGTS(linha)
                    ) {

                        incluirExclusaoDespesasGarantias(valuesAIFT, LABEL.recursosFinanceiros, linha.id)

                    } else {

                        if (linha.valorAporteDividendos) {
                         
                            linha.valorAporteDividendos = 0
                        }

                        if (linha.valorAporteEmpresa) {
                         
                            linha.valorAporteEmpresa = 0
                        }
                    }
                })

                valuesAIFT.seguroVidaApolice?.forEach( (linha, ind) => {

                    incluirExclusaoDespesasGarantias(valuesAIFT, LABEL.seguroVida, linha.id)
                })
            
                processaCalculoEstudoAIFT(valuesAIFT, estudoAIFT, HARDCODE.origemCalculoEstudoEstudo, vars)

                const valuesAIFT2 = geraValuesAIFT(variaveisGlobais, valuesAIFT)
                estudoAIFT2.current = inicializaEstudo()

                let protecaoSugerida

                if (aiFTOrigem === HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente) {

                    protecaoSugerida = values.protecaoSugeridaCliente

                } else {

                    protecaoSugerida = values.protecaoSugeridaConjuge
                }

                let linhaProtecaoSugerida = identificaProtecaoSugerida(protecaoSugerida, LABEL.proporcionarConfortoFamilia)

                const valorCS = linhaProtecaoSugerida.valorCS2

                //linhaProtecaoSugerida = identificaProtecaoSugerida(protecaoSugerida, LABEL.projetoVidaSonho)

                //const valorCSProjetoVidaSonho = linhaProtecaoSugerida.valorCS2

                if (!valuesAIFT2.recursosFinanceiros) {
                    valuesAIFT2.recursosFinanceiros = []
                }

                if (valorCSMorteTemporariaApolice > 0) {

                    valuesAIFT2.recursosFinanceiros.push(
                        {
                            id: obtemContRecursosFinanceiros(valuesAIFT2),
                            familiar: idFamiliar,
                            tipoRecursoFinanceiro: HARDCODE.idTipoRecursoFinanceiroAporteOutros,
                            valor: valorCSMorteTemporariaApolice,
                            descricaoOutros: LABEL.seguroVida,
                        }
                    )
                }

                if (vendaImobilizado > 0) {
                    
                    valuesAIFT2.recursosFinanceiros.push(
                        {
                            id: obtemContRecursosFinanceiros(valuesAIFT2),
                            familiar: idFamiliar,
                            tipoRecursoFinanceiro: HARDCODE.idTipoRecursoFinanceiroAporteVendaImobilizado,
                            valor: vendaImobilizado,
                            descricaoOutros: LABEL.vendaImobilizado,
                        }
                    )
                }
                
                if (valorCS/* - valorCSProjetoVidaSonho*/ > 0) {

                    valuesAIFT2.recursosFinanceiros.push(
                        {
                            id: obtemContRecursosFinanceiros(valuesAIFT2),
                            familiar: idFamiliar,
                            tipoRecursoFinanceiro: HARDCODE.idTipoRecursoFinanceiroAporteOutros,
                            valor: valorCS/* - valorCSProjetoVidaSonho*/,
                            descricaoOutros: LABEL.proporcionarConfortoFamilia,
                        }
                    )
                }

                processaCalculoEstudoAIFT(valuesAIFT2, estudoAIFT2, HARDCODE.origemCalculoEstudoEstudo, vars)

                const aumentoLetra = 2
                const aumentoLetraReport = 1

                return <div>
                    {formataAIFT(MESSAGE().analiseAIFTProtecaoSugeridaSituacaoAtual
                        .replace('$idade$', 
                            calculaIdadeValorNegativo(estudo.current.graficoIdades,
                                estudo.current.graficoIndependenciaFinanceiraSituacaoAtual)),
                                    report, aumentoLetra, aumentoLetraReport, values)}

                    <GridContainer
                        className='mt-3 mb-3'
                    >
                        <GridItem6>
                            <BalancoReceitaXDespesaAnualChart
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                estudo={estudo}
                                vars={vars}
                                report={true}
                                aiFT={true}
                            />
                        </GridItem6>
                        <GridItem6
                            className='mt--14'
                        >
                            <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                values={values}
                                estudo={estudo}
                                report={true}
                                aiFT={true}
                            />
                            {/*
                            <DiagnosticoAposentadoriaChart
                                values={values}
                                handleChange={false}
                                setFieldValue={setFieldValue}
                                estudo={estudo}
                                tipoDiagnosticoAposentadoriaChart={HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual}
                                report={true}
                                aiFT={true}
                            />
                            */}
                        </GridItem6>
                    </GridContainer>

                    {formataAIFT(MESSAGE().analiseAIFTProtecaoSugeridaMorte
                        .replace('$anos$',
                            calculaIdadeValorNegativo(estudoAIFT.current.graficoIdades,
                                estudoAIFT.current.graficoIndependenciaFinanceiraSituacaoAtual) -
                                    values.idadeDataSimulacaoCliente + 1),
                                        report, aumentoLetra, aumentoLetraReport, valuesAIFT)}

                    <GridContainer
                        className='mt-3 mb-3'
                    >
                        <GridItem6>
                            <BalancoReceitaXDespesaAnualChart
                                variaveisGlobais={variaveisGlobais}
                                values={valuesAIFT}
                                estudo={estudoAIFT}
                                vars={vars}
                                report={true}
                                aiFT={true}
                            />
                        </GridItem6>
                        <GridItem6
                            className='mt--14'
                        >
                            <DiagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart
                                values={valuesAIFT}
                                estudo={estudoAIFT}
                                report={true}
                                aiFT={true}
                            />
                            {/*
                            <DiagnosticoAposentadoriaChart
                                values={valuesAIFT}
                                handleChange={false}
                                setFieldValue={setFieldValue}
                                estudo={estudoAIFT}
                                tipoDiagnosticoAposentadoriaChart={HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual}
                                report={true}
                                aiFT={true}
                            />
                            */}
                        </GridItem6>
                    </GridContainer>

                    {formataAIFT(MESSAGE().analiseAIFTProtecaoSugeridaProporcionarConfortoFamilia
                        .replace('$valorCS$', formataValor(valorCS, 2))
                        .replace('$nomeFamiliar$', nomeFamiliar)
                        .replace('$idade$',
                            calculaIdadeValorNegativo(estudoAIFT.current.graficoIdades,
                                estudoAIFT2.current.graficoIndependenciaFinanceiraSituacaoAtual)),
                                    report, aumentoLetra, aumentoLetraReport, valuesAIFT2)}

                    <GridContainer
                        className='mt-3'
                    >
                        <GridItem12
                            className='mt--14'
                        >
                            <DiagnosticoAposentadoriaChart
                                values={valuesAIFT2}
                                handleChange={false}
                                //setFieldValue={setFieldValue}
                                estudo={estudoAIFT2}
                                tipoDiagnosticoAposentadoriaChart={HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual}
                                report={true}
                                aiFT={true}
                            />
                        </GridItem12>
                    </GridContainer>

                    {/*
                    <GridContainer>
                        <GridItem12>
                            <ReceitaAnualChart
                                variaveisGlobais={variaveisGlobais}
                                values={valuesAIFT2}
                                estudo={estudoAIFT2}
                                vars={vars}
                                report={true}
                            />
                        </GridItem12>
                    </GridContainer>

                    <GridContainer>
                        <GridItem12>
                            <DespesaAnualChart
                                values={valuesAIFT2}
                                estudo={estudoAIFT2}
                                vars={vars}
                                report={true}
                            />
                        </GridItem12>
                    </GridContainer>
                    */}
                </div>
            }
        }
        //}
    }

    return formataAIFT(mensagemAIFT, report, 0, 0, values)
}